module.exports = __webpack_public_path__ + "static/media/cbx.85a28198.jpg";